import useApiMutation from 'shared/hooks/use-api-mutation';
import useAccessControls from '../atoms/use-access-controls';
import {useNavigate} from 'react-router-dom';
import useToken from 'modules/auth/atoms/use-token';

const useGrantAccess = () => {
  const {setCityId, setCompanyId, setFranchiseAccessControl} =
    useAccessControls();
  const {setToken} = useToken();
  const navigate = useNavigate();

  const onSuccess = ({
    cityId,
    companyId,
    token,
    isFranchiseAccessControl,
  }: any) => {
    setToken(token);
    setCityId(cityId ?? null);
    setCompanyId(companyId ?? null);
    setFranchiseAccessControl(isFranchiseAccessControl);
    navigate('/');
  };

  return useApiMutation({
    url: '/access-controls/grant-access',
    method: 'POST',
    errorTitle: 'Erro ao entrar',
    onSuccess,
  });
};

export default useGrantAccess;
